import KeyMirror from 'keymirror';

export default KeyMirror({
    GET_VIDEOS_BEGIN: true,
    GET_VIDEOS_SUCCESS: true,
    GET_VIDEOS_ERROR: true,
});
